import { Component, OnInit } from '@angular/core';
import { DatoSolicitudSharedModel } from 'src/app/shared/models/dato-solicitud-shared.model';
import { Subscription } from 'rxjs';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { EncuestaFuncionarioService } from './encuesta-funcionario.service';
import { EncuestaEntry, EncuestaSeccionEntry, EncuestaPreguntasEntry } from 'src/app/shared/entrys/encuesta.entry';
import { TipoPregunta } from 'src/app/shared/enumeraciones/tipo-pregunta.enum';
import { RolesUsuario } from 'src/app/shared/enumeraciones/roles-usuario.enum';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
	selector: 'app-encuesta-funcionario',
	templateUrl: './encuesta-funcionario.component.html',
	styleUrls: ['./encuesta-funcionario.component.scss']
})
export class EncuestaFuncionarioComponent implements OnInit {
	datoSolicitudSharedModel: DatoSolicitudSharedModel;
	suscripcion: Subscription;
	encuestas: Array<EncuestaEntry> = [];
	encuestas_anterior: Array<EncuestaEntry> = [];
	tipo_pregunta_abierta = TipoPregunta.Abierta;
	tipo_pregunta_multiple = TipoPregunta.Multiple;
	tipo_pregunta_unica = TipoPregunta.Unica;
	tipo_pregunta_formula = TipoPregunta.Formula;
	tipo_pregunta_lista_valor = TipoPregunta.ListaValor;
  tipo_prestador = RolesUsuario.Prestador;

	constructor(private dataSharedService: DataSharedService, private encuestaFuncionarioService: EncuestaFuncionarioService,
		public authService: AuthService) {
		this.suscripcion = this.dataSharedService.data$.subscribe(dataShared => {
			this.datoSolicitudSharedModel = dataShared as DatoSolicitudSharedModel;
			this.encuestas = [] as Array<EncuestaEntry>;
		});
	}
	get mensajeError():string{
		return "Encuesta no Diligenciada por el Prestador de Servicios Turísticos";
	}
	ngOnInit() {
		this.encuestaFuncionarioService
			.getEncuesta(this.datoSolicitudSharedModel.data)
			.subscribe(res => {
				if(res.data.length > 0){
					res.data.forEach(respuesta => {
						if (respuesta.flag === 'Actual') {
							this.encuestas.push(respuesta);
						} else {
							this.encuestas_anterior.push(respuesta);
						}
					});
				}
		});
	}
}

